
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 8h16v8H4V8z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 10.25l-2.25 1.875L8 14m8-3.75l2.25 1.875L16 14m-2.5-6l-3 8.25M1 4.81V19a1 1 0 001 1h20a1 1 0 001-1V4.81a.765.765 0 00-.268-.573.982.982 0 00-.649-.237H1.917a.982.982 0 00-.649.237A.765.765 0 001 4.81z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    